import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import Button from '../commons/Button';

import { UNPROXIED_BASE_URL } from '../../constants/constants';

const PDFModal = ({ pdfSrc, isLoading, onClose }) => {
  const [isModalOpen, setIsModalOpened] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsModalOpened(true), 10);
  }, []);

  const handleClose = () => {
    setIsModalOpened(false);
    setTimeout(onClose, 150);
  };

  return (
    <div className={`pdf-modal ${isModalOpen ? '-open' : ''}`}>
      <div className="dialog">
        <div className="body">
          {
            isLoading
              ? <p>Loading...</p>
              : <iframe src={`${UNPROXIED_BASE_URL}/${pdfSrc}`} title="Documentos legales" />
          }
        </div>
        <div className="actions">
          <Button type="button" onClick={handleClose} label="Cerrar" />
        </div>
      </div>
    </div>
  );
};

PDFModal.defaultProps = {
  pdfSrc: '',
};

PDFModal.propTypes = {
  pdfSrc: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PDFModal;
